(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = global || self, factory(global.barStaff = {}));
})(this, function (exports) {
  'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    }
  }
  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }
  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }

  /**
   * Gets the first element matching the provided selector from the DOM.
   * If the provided parameter isn't a string, it's just returned.
   *
   * @param {mixed} selector Selector to get element from
   * @returns {mixed}
   */
  var getDomElement = function getDomElement(selector) {
    return selector.constructor === String ? document.querySelector(selector) : selector;
  };
  var isDomElement = function isDomElement(element) {
    return element instanceof HTMLElement;
  };
  var getScrollBarWidth = function getScrollBarWidth() {
    var parentEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
    var childEl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.documentElement;
    var parent = getDomElement(parentEl);
    var child = getDomElement(childEl);
    if (parent !== window && !isDomElement(parent) || !isDomElement(child)) {
      throw new Error('Expect `window` or instance of `HTMLElement` for ' + '`parentEl` and `instance of `HTMLElement` for childEl ' + 'in `getScrollBarWidth');
    }
    if (parent === window) {
      return parent.innerWidth - child.clientWidth;
    }
    return parent.innerWidth - child.innerWidth;
  };
  var DisableScroll = /*#__PURE__*/
  function () {
    function DisableScroll() {
      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
      _classCallCheck(this, DisableScroll);
      this.disabled = false;
      this._element = getDomElement(element);
      this._keyMap = {
        LEFTARROW: 37,
        UPARROW: 38,
        RIGHTARROW: 39,
        DOWNARROW: 40
      };
      this._onKeydown = this._onKeydown.bind(this);
      this._setAttributes = this._setAttributes.bind(this);
      this._clearAttributes = this._clearAttributes.bind(this);
    }
    _createClass(DisableScroll, [{
      key: "_onTouchMove",
      value: function _onTouchMove(event) {
        event.preventDefault();
      }
    }, {
      key: "_onKeydown",
      value: function _onKeydown(event) {
        var _this = this;
        var code = event.keyCode || event.which;
        Object.keys(this._keyMap).forEach(function (keyCode) {
          if (code === _this._keyMap[keyCode]) {
            event.preventDefault();
          }
        });
      }
    }, {
      key: "_onMouseWheel",
      value: function _onMouseWheel(event) {
        event.preventDefault();
      }
    }, {
      key: "_setAttributes",
      value: function _setAttributes() {
        document.body.style.paddingRight = getScrollBarWidth() + 'px';
        document.body.style.overflow = 'hidden';
        document.body.classList.add('is-scroll-prevented');
      }
    }, {
      key: "_clearAttributes",
      value: function _clearAttributes() {
        document.body.style.paddingRight = null;
        document.body.style.overflow = null;
        document.body.classList.remove('is-scroll-prevented');
      }
    }, {
      key: "disable",
      value: function disable() {
        if (this.disabled) {
          return;
        }
        this._setAttributes();
        this.disabled = true;
        this._element.addEventListener('touchstart', this._onTouchStart);
        this._element.addEventListener('touchmove', this._onTouchMove, {
          passive: false
        });
        this._element.addEventListener('touchend', this._onTouchEnd);
        this._element.addEventListener('keydown', this._onKeydown);
        this._element.addEventListener('wheel', this._onMouseWheel, {
          passive: false
        });
      }
    }, {
      key: "enable",
      value: function enable() {
        if (!this.disabled) {
          return;
        }
        this._clearAttributes();
        this.disabled = false;
        this._element.removeEventListener('touchstart', this._onTouchStart);
        this._element.removeEventListener('touchmove', this._onTouchMove);
        this._element.removeEventListener('touchend', this._onTouchEnd);
        this._element.removeEventListener('wheel', this._onMouseWheel);
        this._element.removeEventListener('keydown', this._onKeydown);
      }
    }]);
    return DisableScroll;
  }();

  /**
   * Shallow remove a single key from an object without mutation.
   *
   * @param {Object} param0 Object to remove key from
   * @param {String} key Key to remove from object
   */
  var omit = function omit(object, key) {
    var _ = object[key],
      rest = _objectWithoutProperties(object, [key].map(_toPropertyKey));
    return rest;
  };
  var DispatcherEvent = /*#__PURE__*/
  function () {
    function DispatcherEvent(eventName) {
      _classCallCheck(this, DispatcherEvent);

      /**
       * Not used internally, for reference when debugging / inspecting.
       *
       * @var {String} _eventName
       */
      this._eventName = eventName;
      /**
       * @var {Array} _callbacks
       */

      this._callbacks = [];
    }
    _createClass(DispatcherEvent, [{
      key: "registerCallback",
      /**
       * Register a new callback.
       *
       * @param {Function} callback
       * @returns {void}
       */
      value: function registerCallback(callback) {
        this._setCallbacks([].concat(_toConsumableArray(this._callbacks), [callback]));
      }
      /**
       * Remove a registered callback, if it exists.
       *
       * @param {Function} callback
       * @returns {void}
       */
    }, {
      key: "unregisterCallback",
      value: function unregisterCallback(callback) {
        var callbacks = this._callbacks;
        var index = callbacks.indexOf(callback);
        if (index > -1) {
          this._setCallbacks([].concat(_toConsumableArray(callbacks.slice(0, index)), _toConsumableArray(callbacks.slice(index + 1))));
        }
      }
      /**
       * Fire callbacks with any data passed.
       *
       * @param {mixed} data
       */
    }, {
      key: "fire",
      value: function fire(data) {
        var callbacks = _toConsumableArray(this._callbacks);
        callbacks.forEach(function (cb) {
          return cb(data);
        });
      }
      /**
       * Replace the existing callbacks.
       *
       * @param {Array} callbacks
       */
    }, {
      key: "_setCallbacks",
      value: function _setCallbacks(callbacks) {
        this._callbacks = callbacks;
      }
    }, {
      key: "callbacks",
      get: function get() {
        return this._callbacks;
      }
    }]);
    return DispatcherEvent;
  }();
  var Dispatcher = /*#__PURE__*/
  function () {
    function Dispatcher() {
      _classCallCheck(this, Dispatcher);

      /**
       * @var {Object} _events
       */
      this._events = {};
    }
    /**
     * Dispatch an event to the subscribed listeners with the given data.
     *
     * Data is not required, and will instead send `undefined`.
     *
     * @param {String} eventName
     * @param {mixed} data
     * @returns {void}
     */

    _createClass(Dispatcher, [{
      key: "dispatch",
      value: function dispatch(eventName, data) {
        var event = this._events[eventName];
        if (event) {
          event.fire(data);
        }
      }
      /**
       * Subscribe a callback to an event listener. If no event listener exists
       * for the supplied event, a new one is created.
       *
       * @param {String} eventName
       * @param {Function} callback
       * @returns {void}
       */
    }, {
      key: "on",
      value: function on(eventName, callback) {
        var event = this._events[eventName];
        if (!event) {
          event = new DispatcherEvent(eventName);
          this._setEvents(_objectSpread2({}, this._events, _defineProperty({}, eventName, event)));
        }
        event.registerCallback(callback);
      }
      /**
       * Unsubscribe a callback from an event listener.
       *
       * @param {String} eventName
       * @param {Function} callback
       * @returns {void}
       */
    }, {
      key: "off",
      value: function off(eventName, callback) {
        var event = this._events[eventName];
        if (event && event.callbacks.indexOf(callback) > -1) {
          event.unregisterCallback(callback);
          if (!event.callbacks.length) {
            this._setEvents(omit(this._events, eventName));
          }
        }
      }
      /**
       * Replace the existing events.
       *
       * @param {Object} events
       */
    }, {
      key: "_setEvents",
      value: function _setEvents(events) {
        this._events = events;
      }
    }]);
    return Dispatcher;
  }();

  /**
   * Detects browser support for the geolocation API.
   *
   * @returns {Boolean}
   */
  var supportsGeolocationAPI = function supportsGeolocationAPI() {
    return 'geolocation' in window.navigator;
  };
  var defaults = {
    enableHighAccuracy: false,
    timeout: 2500,
    maximumAge: 5000
  };
  var getCurrentDeviceLocation = function getCurrentDeviceLocation(options) {
    return new Promise(function (resolve, reject) {
      if (!supportsGeolocationAPI()) {
        return reject(new Error('Browser does not support navigator.geolocation API'));
      }
      return navigator.geolocation.getCurrentPosition(function (position) {
        return resolve(position);
      }, function (err) {
        return reject(err);
      }, _objectSpread2({}, defaults, {}, options));
    });
  };
  var listener = null;
  /**
   * Listen to the device orientation event and return the angle in degrees.
   *
   * @param {Function} callback Function to call when the device orientation changes.
   * @returns {Integer} Angle in degrees the device is pointing towards.
   */

  var listen = function listen(callback) {
    var onOrientationChange = function onOrientationChange(event) {
      var alpha = 0;
      if (event.absolute) {
        alpha = event.alpha;
      } else if (event.webkitCompassHeading) {
        // get absolute orientation for Safari/iOS
        alpha = 360 - event.webkitCompassHeading; // conversion taken from a comment on Google Documentation, not tested
      }

      callback(alpha);
    };
    if ('ondeviceorientationabsolute' in window) {
      listener = window.addEventListener('deviceorientationabsolute', onOrientationChange, true);
    } else if ('ondeviceorientation' in window) {
      listener = window.addEventListener('deviceorientation', onOrientationChange, true);
    }
  };
  /**
   * Clear the set event listener
   *
   * @returns {void}
   */

  var clear = function clear() {
    window.removeEventListener('deviceorientation', listener);
  };
  var getDeviceOrientation = function getDeviceOrientation() {
    return {
      listen: listen,
      clear: clear
    };
  };
  var getElementOffset = function getElementOffset(element) {
    var el = getDomElement(element);
    var rect = el.getBoundingClientRect();
    return {
      bottom: rect.bottom - window.scrollY,
      left: rect.left + window.scrollX,
      right: rect.right - window.scrollX,
      top: rect.top + window.scrollY
    };
  };
  var getFocusableElements = function getFocusableElements() {
    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var element = getDomElement(target);
    return element.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  };

  /**
   * Invert the given objects keys and values.
   *
   * invertObject({key1: 'value_1',key3: 'value_3',key2: 'value_2'})
   *   // { value_1: 'key1', value_3: 'key3', value_2: 'key2' }
   *
   * @param {Object} obj Input object.
   * @returns {Object} Inverted object.
   */
  var invertObject = function invertObject(obj) {
    return Object.keys(obj).reduce(function (acc, item) {
      var key = obj[item];
      acc[key] = item;
      return acc;
    }, {});
  };

  /**
   * Get whether the device is mobile or not.
   *
   * Note: This check may not be 100% foolproof.
   *
   * @returns {Boolean}
   */
  var isMobileDevice = function isMobileDevice() {
    return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
  };

  /**
   * Get whether the device is desktop or not.
   *
   * Note: This check may not be 100% foolproof.
   *
   * @returns {Boolean}
   */

  var isDesktopDevice = function isDesktopDevice() {
    return !isMobileDevice();
  };

  /**
   * Run a function against each item in the given object.
   *
   * mapObject({key1: 20}, (value) => { return value * 2 }) // { key1: 40 }
   *
   * @param {Object} obj Input object.
   * @param {Function} fn Function to run against each item in the given object.
   * @returns {Object}
   */
  var mapObject = function mapObject(obj, fn) {
    return Object.keys(obj).reduce(function (result, key) {
      result[key] = fn(obj[key], key);
      return result;
    }, {});
  };
  function replaceText(string, replacements) {
    var updated = string;
    Object.keys(replacements).forEach(function (key) {
      var regex = new RegExp("{{( ?".concat(key, " ?)}}"), 'g');
      updated = updated.replace(regex, replacements[key]);
    });
    return updated;
  }

  /**
   * Get whether the device supports the device orientation event.
   *
   * @returns {Boolean}
   */
  var supportsOrientationEvent = function supportsOrientationEvent() {
    return window.DeviceOrientationEvent;
  };

  /**
   * Convert the given string into a camelCase'd representation. Will replace
   * anything that isn't a AlphaNumeric character with nothing.
   *
   * @param {string} str Input string
   * @returns {string} String converted to camelCase
   * @link https://stackoverflow.com/a/52551910/1694116
   */
  var toCamelCase = function toCamelCase(str) {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, firstChar) {
      return firstChar.toUpperCase();
    });
  };

  /**
   * Will translate provided input values to provided dictionary values. Useful
   * for using consistent data for consumption by an API, but more dev friendly
   * keys.
   *
   * translateObject({ key1: 'key_1' }, { key1: 'value 1' })
   *     // { key_1: 'value 1' }
   *
   * @param {Object} dictionary Key / value pair, similar to a Map
   * @param {Object} input Keys to translate to dictionary values
   * @returns {Object} Processed object
   */

  var translateObject = function translateObject(dictionary, input) {
    var out = {};
    mapObject(dictionary, function (item, key) {
      if (input[key] !== undefined) {
        out[item] = input[key];
      }
    });
    return out;
  };

  /**
   * Same as translateObject, but will inverse the dictionary keys before running.
   * Useful to convert an API response to consistent easier to use data by a
   * consumer.
   *
   * translateObjectInverse({ key1: 'key_1' }, { key_1: 'value 1' })
   *    // { key1: 'value 1' }
   *
   * @param {Object} dictionary Key / value pair, similar to a Map
   * @param {Object} input Keys to translate to dictionary values
   * @returns {Object} Process object.
   */

  var translateObjectInverse = function translateObjectInverse(dictionary, input) {
    return translateObject(invertObject(dictionary), input);
  };
  var defaults$1 = {
    enableHighAccuracy: true,
    timeout: 1000,
    maximumAge: 250
  };
  var watchLocation = function watchLocation(options) {
    var watchID = null;
    var stop = function stop() {
      if (watchID) {
        navigator.geolocation.clearWatch(watchID);
      }
    };
    var start = function start(success) {
      if (!supportsGeolocationAPI) {
        throw new Error('Browser does not support navigator.geolocation API');
      }
      stop();
      watchID = navigator.geolocation.watchPosition(success, stop, _objectSpread2({}, defaults$1, {}, options));
    };
    return {
      start: start,
      stop: stop
    };
  };
  exports.DisableScroll = DisableScroll;
  exports.Dispatcher = Dispatcher;
  exports.getCurrentDeviceLocation = getCurrentDeviceLocation;
  exports.getDeviceOrientation = getDeviceOrientation;
  exports.getDomElement = getDomElement;
  exports.getElementOffset = getElementOffset;
  exports.getFocusableElements = getFocusableElements;
  exports.getScrollBarWidth = getScrollBarWidth;
  exports.invertObject = invertObject;
  exports.isDesktopDevice = isDesktopDevice;
  exports.isDomElement = isDomElement;
  exports.isMobileDevice = isMobileDevice;
  exports.mapObject = mapObject;
  exports.omit = omit;
  exports.replaceText = replaceText;
  exports.supportsGeolocationAPI = supportsGeolocationAPI;
  exports.supportsOrientationEvent = supportsOrientationEvent;
  exports.toCamelCase = toCamelCase;
  exports.translateObject = translateObject;
  exports.translateObjectInverse = translateObjectInverse;
  exports.watchDeviceLocation = watchLocation;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});